import { ButtonHTMLAttributes, ComponentProps, forwardRef } from 'react';
import cn from 'clsx';
import { PolymorphicComponent } from '../types';

import styles from './Button.module.scss';

const defaultElement = 'button' as const;

export type ButtonOwnProps = {
  variant?: 'button' | 'link' | 'big' | 'phantom' | 'light';
  square?: boolean;
  type?: ButtonHTMLAttributes<unknown>['type'];
  className?: string;
};

type ButtonComponent = PolymorphicComponent<'button', ButtonOwnProps>;

export const Button = forwardRef(
  (
    {
      className,
      variant = 'button',
      children,
      square,
      type = 'button',
      as: Element = defaultElement,
      ...restProps
    }: ComponentProps<ButtonComponent>,
    ref,
  ) => (
    <Element
      ref={ref}
      type={type}
      className={cn(styles.buttonBase, styles[variant], className, {
        [styles.square]: square,
      })}
      {...restProps}
    >
      <span className={styles.container}>{children}</span>
    </Element>
  ),
) as ButtonComponent;
